import Link from "next/link";
import { Faq } from "@repo/next-shared/data/faq";
import { Card } from "@repo/ui/components/ui/card";
import Icon from "@repo/ui/components/ui/icon/icon";
import { useParams } from "next/navigation";
import RichText from "../rich-text";

export default function HelpItems({ items }: { items: Array<Faq> }) {
  const params = useParams();
  const linkPrefix = params?.id ? "" : "help/faq/";

  return (
    <div className="mt-5 max-md:mt-4 grid grid-cols-2 max-md:grid-cols-1 gap-5 max-md:gap-2">
      {items.map((item, i) => {
        return (
          <Link
            href={`${linkPrefix}${item.id}`}
            id={item.title + item.id}
            key={item.title + i + "link"}
          >
            <Card
              key={item.title + i}
              className="flex items-center gap-10 p-10 max-md:p-4"
            >
              <div className="grow-0">
                <h5 className="font-bold text-[20px] max-md:text-[16px] line-clamp-2 h-[2em] max-md:h-auto max-md:line-clamp-none">
                  {item.title}
                </h5>
                <p className="mt-8 text-sm line-clamp-3 h-[4em] max-md:h-auto max-md:line-clamp-2">
                  {<RichText>{item.content}</RichText>}
                </p>
              </div>
              <div className="basis-[16px] max-md:basis-[12px] grow-0 shrink-0">
                <Icon
                  icon="Arrow"
                  className="stroke-primary-magenta dark:stroke-primary-white"
                />
              </div>
            </Card>
          </Link>
        );
      })}
    </div>
  );
}
